import { CargoOperationViewModel } from 'src/types/ViewModel/Stowage/CargoOperation/CargoOperationViewModel';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { createStowagePlanChange } from 'src/factory/Stowage/StowagePlanChanges/StowagePlanChangeFactory';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import { createCargoOperationChangeData } from 'src/factory/Stowage/StowagePlanChanges/StowageChangeData/CargoOperationChangeDataFactory';

export const convertToNumber = (value: string | number | null): number => {
    if (value === null || value === '') return 0;
    const num = Number(value);
    return isNaN(num) ? 0 : num;
};

export const updateStateAndValidate = (
    cargoOperationVM: CargoOperationViewModel,
    name: string,
    isValid: boolean,
    setCargoOperationVM: (value: CargoOperationViewModel) => void
): void => {
    if (!isValid) {
        cargoOperationVM[name] = null;
    }
    setCargoOperationVM({ ...cargoOperationVM });
};

export const isEmptyObject = (obj: unknown): boolean => {
    // Check if object is null or undefined
    if (obj == null) return true;

    // Check if it's an object
    if (typeof obj !== 'object') return false;

    // Handle arrays
    if (Array.isArray(obj)) return obj.length === 0;

    // Check if it's a Date object
    if (obj instanceof Date) return false;

    // For plain objects, check if it has any own enumerable properties
    return Object.keys(obj as object).length === 0;
};

export const unloadCargoOperation = (stowagePlan: StowagePlan, cargoOperation: CargoOperationViewModel): StowagePlanChange[] => {
    if (!cargoOperation.unloadingBerthCall || !cargoOperation.cargo) {
        return null;
    }

    const changes: StowagePlanChange[] = [];

    // Create unload operation with the same properties as load operation
    const unloadOperation: CargoOperationViewModel = {
        ...cargoOperation,
        cargoOperationGuid: crypto.randomUUID(),
        portCallGuid: cargoOperation.unloadingBerthCall.portCall.portCallGuid,
        berthCallGuid: cargoOperation.unloadingBerthCall.berthCallGuid,
        berthCall: cargoOperation.unloadingBerthCall,
        operationType: 'Unloading',
        cargoOperationSequenceNumber: 0, // This will be set by the backend
    };

    const unloadOperationChangeData = createCargoOperationChangeData(unloadOperation);
    changes.push(
        createStowagePlanChange(
            stowagePlan.stowagePlanGuid,
            unloadOperation.cargoOperationGuid,
            StowageChangeDataType.RotationCargoOperation,
            unloadOperationChangeData
        )
    );

    return changes;
};
